/** Alibaba Cloud's regions, as Model Studio names them. */
export const ALIBABA_SINGAPORE = "ap-southeast-1";
export const ALIBABA_VIRGINIA = "us-east-1";
export const ALIBABA_BEIJING = "cn-beijing";

/**
 * The model as its lab names it, whichever route asked for it: `anthropic/claude-haiku-4.5` and
 * `claude-haiku-4-5-20251001` are both `claude-haiku-4-5`. Analytics groups models by the same
 * rule in SQL.
 */
export function canonicalModelName(model: string): string {
  const name = model.slice(model.lastIndexOf("/") + 1);
  return (name.startsWith("claude") ? name.replaceAll(".", "-") : name).replace(/-\d{8}$/, "");
}

/**
 * The organization that trained a model's weights, whoever serves them: the vendor in a routed name
 * such as `deepseek/deepseek-v3.2`, or the lab a bare name belongs to. Nothing for a bare name no
 * lab is known for.
 */
export function modelCreator(model: string): string | undefined {
  const slash = model.indexOf("/");
  if (slash > 0) return model.slice(0, slash);
  if (model.startsWith("claude")) return "anthropic";
  if (/^(gpt|o\d|codex)/.test(model)) return "openai";
  if (/^(gemini|gemma)/.test(model)) return "google";
  if (model.startsWith("qwen")) return "qwen";
  if (model.startsWith("glm")) return "z-ai";
  return undefined;
}
